import { render } from "./LLargu.vue?vue&type=template&id=72505639&scoped=true"
import script from "./LLargu.vue?vue&type=script&lang=js"
export * from "./LLargu.vue?vue&type=script&lang=js"

import "./LLargu.vue?vue&type=style&index=0&id=72505639&lang=scss&scoped=true"
import "./LLargu.vue?vue&type=style&index=1&id=72505639&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72505639"]])

export default __exports__